import React from "react";
import { Calendar, Search } from "react-feather";
import { ComplaintsRelatedToWithSubCategory } from "../../../../utils/enums";
import { State } from "country-state-city";

export interface FilterData {
  search: string;
  complainant_name: string;
  complainant_org: string;
  complainant_state: string;
  status: string;
  complainant_number: string;
  serviceDeskId: string;
  callStatus: string;
  fromDate: string;
  toDate: string;
  complaint_related_to: string;
  subcategory_of_related_to: string;
  direction: string;
}

interface IncidentTrackerFiltersProps {
  filters: FilterData;
  showFilters: boolean;
  loading: boolean;
  onFilterChange: (field: keyof FilterData, value: string) => void;
  onClearFilters: () => void;
  onApplyFilter: (field: keyof FilterData) => void;
}

const IncidentTrackerFilters: React.FC<IncidentTrackerFiltersProps> = ({
  filters,
  showFilters,
  loading,
  onFilterChange,
  onClearFilters,
  onApplyFilter,
}) => {
  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    field: keyof FilterData
  ) => {
    if (e.key === "Enter") {
      onApplyFilter(field);
    }
  };

  const complaint_categories = Object.keys(
    ComplaintsRelatedToWithSubCategory
  ).sort();

  const subCategories = (
    ComplaintsRelatedToWithSubCategory[filters.complaint_related_to] || []
  )
    .slice()
    .sort();

  const areAllFiltersEmpty = Object.values(filters).every((val) => val === "");

  return (
    <>
      {showFilters && (
        <div className="p-4 mb-6">
          <div className="flex justify-end items-center mb-4">
            <button
              id="incident_tracker_filters_clear_all_btn"
              onClick={onClearFilters}
              className="text-sm text-gray-600 hover:text-gray-800"
              disabled={loading || areAllFiltersEmpty}
            >
              Clear All
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {/* Service Desk ID */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Service Desk ID
              </label>
              <div className="flex border border-gray-300 rounded-md">
                <input
                  id="incident_tracker_service_desk_id_filter"
                  type="text"
                  placeholder="INC-202425"
                  value={filters.serviceDeskId}
                  onChange={(e) =>
                    onFilterChange("serviceDeskId", e.target.value)
                  }
                  onKeyDown={(e) => handleKeyDown(e, "serviceDeskId")}
                  className="w-full px-3 py-2 border-r border-gray-300 rounded-l-md"
                />
                <button
                  id="incident_tracker_service_desk_id_apply_btn"
                  type="button"
                  onClick={() => onApplyFilter("serviceDeskId")}
                  className="px-2 text-gray-500 hover:text-gray-700"
                >
                  <Search size={18} />
                </button>
              </div>
            </div>
            {/* Complainant Number */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Complainant Number
              </label>
              <div className="flex border border-gray-300 rounded-md">
                <input
                  id="incident_tracker_complainant_number_filter"
                  type="text"
                  placeholder="9301420895"
                  value={filters.complainant_number}
                  onChange={(e) =>
                    onFilterChange("complainant_number", e.target.value)
                  }
                  onKeyDown={(e) => handleKeyDown(e, "complainant_number")}
                  className="w-full px-3 py-2 border-r border-gray-300 rounded-l-md"
                />
                <button
                  id="incident_tracker_complainant_number_apply_btn"
                  type="button"
                  onClick={() => onApplyFilter("complainant_number")}
                  className="px-2 text-gray-500 hover:text-gray-700"
                >
                  <Search size={18} />
                </button>
              </div>
            </div>
            {/* Complainant Name */}
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Complainant Name
              </label>
              <div className="flex border border-gray-300 rounded-md">
                <input
                  type="text"
                  placeholder="John Doe"
                  value={filters.complainant_name}
                  onChange={(e) =>
                    onFilterChange("complainant_name", e.target.value)
                  }
                  onKeyDown={(e) => handleKeyDown(e, "complainant_name")}
                  className="w-full px-3 py-2 border-r border-gray-300 rounded-l-md"
                />
                <button
                  type="button"
                  onClick={() => onApplyFilter("complainant_name")}
                  className="px-2 text-gray-500 hover:text-gray-700"
                >
                  <Search size={18} />
                </button>
              </div>
            </div> */}
            {/* Organization */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Organization
              </label>
              <div className="flex border border-gray-300 rounded-md">
                <input
                  id="incident_tracker_complainant_org_filter"
                  type="text"
                  placeholder="Tech Corp"
                  value={filters.complainant_org}
                  onChange={(e) =>
                    onFilterChange("complainant_org", e.target.value)
                  }
                  onKeyDown={(e) => handleKeyDown(e, "complainant_org")}
                  className="w-full px-3 py-2 border-r border-gray-300 rounded-l-md"
                />
                <button
                  id="incident_tracker_complainant_org_apply_btn"
                  type="button"
                  onClick={() => onApplyFilter("complainant_org")}
                  className="px-2 text-gray-500 hover:text-gray-700"
                >
                  <Search size={18} />
                </button>
              </div>
            </div>
            {/* Complaint Related To */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Complaint Related To
              </label>
              <div className="flex border border-gray-300 rounded-md">
                <select
                  id="incident_tracker_complaint_related_to_filter"
                  value={filters.complaint_related_to}
                  onChange={(e) =>
                    onFilterChange("complaint_related_to", e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                >
                  <option value="">All Categories</option>
                  {complaint_categories.map((category: any, i) => (
                    <option key={i} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Complaint Related To */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Subcategory of Related To
              </label>
              <div className="flex border border-gray-300 rounded-md">
                <select
                  id="incident_tracker_subcategory_filter"
                  value={filters.subcategory_of_related_to}
                  onChange={(e) =>
                    onFilterChange("subcategory_of_related_to", e.target.value)
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                >
                  <option value="">All Categories</option>
                  {subCategories.map((category: any, i) => (
                    <option key={i} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Organization */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                State
              </label>
              <div className="flex border border-gray-300 rounded-md">
                <select
                  id="incident_tracker_complainant_state_filter"
                  value={filters.complainant_state}
                  onChange={(e) =>
                    onFilterChange("complainant_state", e.target.value)
                  }
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="">Select a state</option>
                  {State.getStatesOfCountry("IN").map((state) => (
                    <option key={state.isoCode} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
                <button
                  id="incident_tracker_complainant_state_apply_btn"
                  type="button"
                  onClick={() => onApplyFilter("complainant_state")}
                  className="px-2 text-gray-500 hover:text-gray-700"
                >
                  <Search size={18} />
                </button>
              </div>
            </div>
            {/* Status */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Service Desk Status
              </label>
              <select
                id="incident_tracker_status_filter"
                value={filters.status}
                onChange={(e) => onFilterChange("status", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option value="">All Statuses</option>
                <option value="Open">Open</option>
                <option value="Resolved">Resolved</option>
                <option value="Escalated">Escalated</option>
              </select>
            </div>
            {/* Call Status */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Call Status
              </label>
              <select
                id="incident_tracker_call_status_filter"
                value={filters.callStatus}
                onChange={(e) => onFilterChange("callStatus", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option value="">All</option>
                <option value="answered">Answered</option>
                <option value="missed">Missed</option>
              </select>
            </div>
            {/* Call Type (direction) */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Call Type (direction)
              </label>
              <select
                id="incident_tracker_direction_filter"
                value={filters.direction}
                onChange={(e) => onFilterChange("direction", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option value="">All</option>
                <option value="inbound">Incoming</option>
                <option value="outbound">Outgoing</option>
              </select>
            </div>
            {/* Date Range */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                From Date
              </label>
              <div className="relative">
                <Calendar
                  size={16}
                  className="absolute left-3 top-2.5 text-gray-400"
                />
                <input
                  id="incident_tracker_from_date_filter"
                  type="date"
                  value={filters.fromDate ? filters.fromDate.split("T")[0] : ""}
                  onChange={(e) => onFilterChange("fromDate", e.target.value)}
                  className="pl-9 w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                To Date
              </label>
              <div className="relative">
                <Calendar
                  size={16}
                  className="absolute left-3 top-2.5 text-gray-400"
                />
                <input
                  id="incident_tracker_to_date_filter"
                  type="date"
                  value={filters.toDate ? filters.toDate.split("T")[0] : ""}
                  onChange={(e) => onFilterChange("toDate", e.target.value)}
                  className="pl-9 w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default IncidentTrackerFilters;
